export default "__VITE_ASSET__bc86c1e7__"